import { MAX_ITEMS_IN_PAGE } from "../../actions/commonActions";

const initState = {
  timesheets: [],
  timesheet: {},
  selectedWeek: {},
  numRows: 1,
  timesheetDates: [],
  timesheetEntries: [
    {
      entry_id: 1,
      project_id: 0,
      task_id: 0,
    },
  ],
  durationEntries: [],
  entryIdsToDelete: [],
  monthlyEntries: [],
  timesheetLoader: false,
  entriesByProject: {},
  overTimeEntries: [],
  timeEntriesPerProject: [], //group per band
  approvedTimeEntries: [],
  additionalTimeEntries: [],
  additionalTimesheetDates: [],
  currentPage: 1,
  totalPages: 0,
  numItems: 0,
  min: 1,
  max: MAX_ITEMS_IN_PAGE,
};

const timesheetReducer = (state = initState, action) => {
  switch (action.type) {
    case "TIMESHEET_SET_FIELD_VALUE":
      return {
        ...state,
        timesheet: Object.assign(state.timesheet, action.value),
      };
    case "FETCH_TIMESHEETS":
      return {
        ...state,
        timesheets: action.timesheet,
      };
    case "SET_SELECTED_WEEK":
      return {
        ...state,
        selectedWeek: action.week,
      };
    case "ADD_DATES":
      return {
        ...state,
        timesheetDates: [...state.timesheetDates, action.value],
      };
    case "ADD_ADDITIONAL_DATES":
      return {
        ...state,
        additionalTimesheetDates: [
          ...state.additionalTimesheetDates,
          action.value,
        ],
      };
    case "SET_TIMESHEET":
      return {
        ...state,
        timesheet: action.timesheet,
      };
    case "RESET_TIMESHEET":
      return {
        ...state,
        timesheet: {},
        additionalTimeEntries: [],
        selectedWeek: {},
        timesheetDates: [],
        additionalTimesheetDates: [],
      };
    case "RESET_TIMESHEET_ENTRIES":
      return {
        ...state,
        timesheetEntries: [
          {
            entry_id: 1,
            project_id: 0,
            task_id: 0,
          },
        ],
        additionalTimeEntries: [],
        numRows: 1,
        durationEntries: [],
        timesheetDates: [],
        selectedWeek: {},
      };
    case "CLEAR_TIMESHEET_ENTRIES":
      return {
        ...state,
        timesheetEntries: [],
      };
    case "UPDATE_TIMESHEET_ENTRIES":
      return {
        ...state,
        timesheetEntries: action.timesheetEntries,
      };
    case "UPDATE_ADDITIONAL_TIMESHEET_ENTRIES":
      return {
        ...state,
        additionalTimeEntries: action.additionalTimeEntries,
      };
    case "ADD_TIMESHEET_ENTRY":
      return {
        ...state,
        timesheetEntries: state.timesheetEntries.map((timesheetEntry) =>
          timesheetEntry.entry_id === action.entry_id
            ? { ...timesheetEntry, [action.id]: action.value }
            : timesheetEntry
        ),
      };
    case "ADD_ADDITIONAL_TIMESHEET_ENTRY":
      return {
        ...state,
        additionalTimeEntries: state.additionalTimeEntries.map(
          (additionalTimeEntry) =>
            additionalTimeEntry.entry_id === action.entry_id
              ? { ...additionalTimeEntry, [action.id]: action.value }
              : additionalTimeEntry
        ),
      };
    case "ADD_TIMESHEET_ENTRY_DATE":
      return {
        ...state,
        durationEntries: [...state.durationEntries, action.entry],
      };
    case "SHOW_TIMESHEET_LOADER":
      return {
        ...state,
        timesheetLoader: action.show,
      };
    case "UPDATE_TIMESHEET_DURATIONS":
      return {
        ...state,
        durationEntries: action.newDurations,
      };
    case "ADD_ROW_NUM":
      return {
        ...state,
        numRows: state.numRows + 1,
        additionalTimeEntries: [
          ...state.additionalTimeEntries,
          { entry_id: state.numRows + 1, project_id: 0, task_id: 0 },
        ],
      };
    case "DECREASE_NUM_ROW":
      return {
        ...state,
        numRows: state.numRows - 1,
      };
    case "SET_ROW_NUM":
      return {
        ...state,
        numRows: action.numRows,
      };
    case "ADD_TIMESHEET_REMARKS":
      return {
        ...state,
        timesheet: Object.assign(state.timesheet, action.remarks),
      };
    case "ADD_ENTRY_TO_DELETE":
      return {
        ...state,
        entryIdsToDelete: [...state.entryIdsToDelete, action.entryId],
      };
    case "CLEAR_ENTRY_TO_DELETE":
      return {
        ...state,
        entryIdsToDelete: [],
      };
    case "SET_MONTHLY_ENTRIES":
      return {
        ...state,
        monthlyEntries: action.monthlyEntries,
      };
    case "RESET_MONTHLY_ENTRIES":
      return {
        ...state,
        monthlyEntries: [],
      };
    case "GET_ENTRIES_BY_PROJECT_ID":
      return {
        ...state,
        entriesByProject: Object.assign(state.entriesByProject, {
          [action.projectId]: action.newEntries,
        }),
      };
    case "ADD_OVERTIME_ENTRIES":
      return {
        ...state,
        overTimeEntries: [
          ...state.overTimeEntries,
          {
            entryDate: action.entryDate,
            showPopover: action.show,
            isTag: action.isTag,
            otHours: action.otHours,
            isUnTagging: action.isUnTag,
            entryId: action.entryId,
          },
        ],
      };
    case "SET_OVERTIME_ENTRIES":
      return {
        ...state,
        overTimeEntries: action.overTimeEntries,
      };
    case "GET_TIME_ENTRIES_PER_PROJECT":
      return {
        ...state,
        timeEntriesPerProject: [
          ...state.timeEntriesPerProject,
          action.timeEntries,
        ],
      };
    case "RESET_TIME_ENTRIES_PER_PROJECT":
      return {
        ...state,
        timeEntriesPerProject: [],
      };
    case "GET_APPROVED_TIME_ENTRIES":
      return {
        ...state,
        approvedTimeEntries: [
          ...state.approvedTimeEntries,
          ...action.timeEntries,
        ],
      };
    case "CLEAR_APPROVED_TIME_ENTRIES":
      return {
        ...state,
        approvedTimeEntries: [],
      };
    case "SET_TIMESHEET_PAGINATION":
      return {
        ...state,
        numItems: action.numItems,
        min: action.min,
        totalPages: action.totalPages,
        currentPage:
          typeof action.currentPage !== "undefined"
            ? action.currentPage
            : state.currentPage,
        max: action.max,
      };
    case "RESET_TIMESHEET_PAGINATION":
      return {
        ...state,
        currentPage: 1,
        totalPages: 0,
        numRows: 0,
        min: 1,
        max: MAX_ITEMS_IN_PAGE,
      };
    default:
      return state;
  }
};

export default timesheetReducer;
